/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { RFCDate } from "../types/rfcdate.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

/**
 * schema mapping for AccountBalances Model
 */
export type TreasuryAccountBalances = {
  canisterId: string;
  ledgerCanisterId: string;
  day: RFCDate;
  timestamp: string;
  balance: string;
};

/** @internal */
export const TreasuryAccountBalances$inboundSchema: z.ZodType<
  TreasuryAccountBalances,
  z.ZodTypeDef,
  unknown
> = z.object({
  canister_id: z.string(),
  ledger_canister_id: z.string(),
  day: z.string().transform(v => new RFCDate(v)),
  timestamp: z.string(),
  balance: z.string(),
}).transform((v) => {
  return remap$(v, {
    "canister_id": "canisterId",
    "ledger_canister_id": "ledgerCanisterId",
  });
});

/** @internal */
export type TreasuryAccountBalances$Outbound = {
  canister_id: string;
  ledger_canister_id: string;
  day: string;
  timestamp: string;
  balance: string;
};

/** @internal */
export const TreasuryAccountBalances$outboundSchema: z.ZodType<
  TreasuryAccountBalances$Outbound,
  z.ZodTypeDef,
  TreasuryAccountBalances
> = z.object({
  canisterId: z.string(),
  ledgerCanisterId: z.string(),
  day: z.instanceof(RFCDate).transform(v => v.toString()),
  timestamp: z.string(),
  balance: z.string(),
}).transform((v) => {
  return remap$(v, {
    canisterId: "canister_id",
    ledgerCanisterId: "ledger_canister_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace TreasuryAccountBalances$ {
  /** @deprecated use `TreasuryAccountBalances$inboundSchema` instead. */
  export const inboundSchema = TreasuryAccountBalances$inboundSchema;
  /** @deprecated use `TreasuryAccountBalances$outboundSchema` instead. */
  export const outboundSchema = TreasuryAccountBalances$outboundSchema;
  /** @deprecated use `TreasuryAccountBalances$Outbound` instead. */
  export type Outbound = TreasuryAccountBalances$Outbound;
}

export function treasuryAccountBalancesToJSON(
  treasuryAccountBalances: TreasuryAccountBalances,
): string {
  return JSON.stringify(
    TreasuryAccountBalances$outboundSchema.parse(treasuryAccountBalances),
  );
}

export function treasuryAccountBalancesFromJSON(
  jsonString: string,
): SafeParseResult<TreasuryAccountBalances, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TreasuryAccountBalances$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TreasuryAccountBalances' from JSON`,
  );
}
